import { InvestmentTypeHiringStepEntity } from '../entities/investment-type-hiring-step-entity';

export default class InvestmentTypeHiringStepState {
  loaded = false;

  items: Array<InvestmentTypeHiringStepEntity> = [];
}
